import React from "react";
import { Spin } from "antd";
import { EditForm } from "./EditForm";
import { CustomModal } from "../common/CustomModal";
import { withRouter } from "react-router";
import { connect } from "react-redux";

class EditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false, // Fixme this should be true
      closable: true,
    };
  }

  componentDidMount() {
    console.log(this.props.refx)
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState({
      visible: false,
    });
    this.props.onClose();
  }

  render() {

    const {loginUserData, authToken} = this.props;
    console.log("Login: ", loginUserData)
    return (
      <CustomModal
        width="600px"
        visible={this.state.visible}
        title="Edit User"
        onCancel={this.handleCancel}
        destroyOnClose={true}
      >
        {this.state.isLoading ? (
          <div style={{ justifyContent: "center" }}>
            <Spin />
          </div>
        ) : (
          <EditForm
            data={this.props.userSelectedData}
            onSubmit={this.props.onSubmit}
            handleCancel={this.handleCancel}
            loginData={this.props.loginUserData}
            Token={this.props.authToken}
          />
        )}
      </CustomModal>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
});

export default connect(mapStateToProps)(withRouter(EditModal));